import { createAction } from '@reduxjs/toolkit'

export const initSystemData = createAction<{
  serviceShutdownAt: number
  serviceOpenAt: number
  isEnableMaintenanceMode: boolean
}>('system/initSystemData')
